import { Platform } from 'constants/api';
import { SOURCE } from 'constants/general';
import { CONTACT_US_LINK } from 'constants/links';

import { uaParser } from 'services/Analytics/core';

import { getLocalizationFromAvailable } from 'helpers/localization';
import { LS_KEYS } from 'helpers/localStorage';

import { IGenerateContactUsLink } from './types';

export const getDeviceInfo = () => {
    const UAParser = new uaParser();
    const userAgentParsed = UAParser.setUA(window.navigator.userAgent);

    const os = userAgentParsed.getOS();
    const browser = userAgentParsed.getBrowser();

    return {
        os: `${os.name} ${os.version}`,
        browser: `${browser.name} ${browser.version}`,
    };
};

export const generateContactUsLink = ({
    first_name,
    email,
    id,
    payment_platform,
    gender,
    country,
    authToken,
}: IGenerateContactUsLink) => {
    const localization = getLocalizationFromAvailable();
    const { os, browser } = getDeviceInfo();
    const uuid = localStorage.getItem(LS_KEYS.uuid);

    const queryParams = new URLSearchParams({
        locale: localization,
        name: first_name ?? '',
        user_id: id ? String(id) : '',
        email: email ?? '',
        os_version: os,
        model: browser,
        payment_platform: payment_platform ? Platform[payment_platform] : '',
        source: SOURCE,
        gender: gender ?? '',
        country: country ?? '',
        uuid: uuid ?? '',
        auth_token: authToken ?? '',
    });

    return `${CONTACT_US_LINK}?${queryParams.toString()}`;
};
